import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "color", "disabled", "gradientDuoTone", "gradientMonochrome", "href", "label", "outline", "pill", "fullSized", "positionInGroup", "size", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useTheme } from '../Flowbite/ThemeContext';
import ButtonGroup from './ButtonGroup';
var ButtonComponent = forwardRef(function (_ref, ref) {
  var _theme$outline$color$;
  var children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'info' : _ref$color,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    gradientDuoTone = _ref.gradientDuoTone,
    gradientMonochrome = _ref.gradientMonochrome,
    href = _ref.href,
    label = _ref.label,
    _ref$outline = _ref.outline,
    outline = _ref$outline === void 0 ? false : _ref$outline,
    _ref$pill = _ref.pill,
    pill = _ref$pill === void 0 ? false : _ref$pill,
    fullSized = _ref.fullSized,
    _ref$positionInGroup = _ref.positionInGroup,
    positionInGroup = _ref$positionInGroup === void 0 ? 'none' : _ref$positionInGroup,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var isLink = typeof href !== 'undefined';
  var _useTheme$theme = useTheme().theme,
    groupTheme = _useTheme$theme.buttonGroup,
    theme = _useTheme$theme.button;
  var Component = isLink ? 'a' : 'button';
  var theirProps = props;
  return _jsx(Component, _objectSpread(_objectSpread({
    className: classNames(disabled && theme.disabled, !gradientDuoTone && !gradientMonochrome && theme.color[color], gradientDuoTone && !gradientMonochrome && theme.gradientDuoTone[gradientDuoTone], !gradientDuoTone && gradientMonochrome && theme.gradient[gradientMonochrome], groupTheme.position[positionInGroup], outline && ((_theme$outline$color$ = theme.outline.color[color]) !== null && _theme$outline$color$ !== void 0 ? _theme$outline$color$ : theme.outline.color.default), theme.base, theme.pill[pill ? 'on' : 'off'], fullSized && theme.fullSized, className),
    disabled: disabled,
    href: href,
    type: isLink ? undefined : 'button',
    ref: ref
  }, theirProps), {}, {
    children: _jsx("span", {
      className: classNames(theme.inner.base, theme.inner.position[positionInGroup], theme.outline[outline ? 'on' : 'off'], theme.outline.pill[outline && pill ? 'on' : 'off'], theme.size[size], outline && !theme.outline.color[color] && theme.inner.outline),
      children: _jsxs(_Fragment, {
        children: [typeof children !== 'undefined' && children, typeof label !== 'undefined' && _jsx("span", {
          className: theme.label,
          "data-testid": "flowbite-button-label",
          children: label
        })]
      })
    })
  }));
});
ButtonComponent.displayName = 'Button';
export var Button = Object.assign(ButtonComponent, {
  Group: ButtonGroup
});